import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ComicCard from '@/components/feature/ComicCard';
import { categories, allComics } from '@/mocks/comics';
import { Link } from 'react-router-dom';

export default function CategoryPage() {
  const { categoryId } = useParams<{ categoryId: string }>();
  const category = categories.find((c) => c.id === categoryId);

  const categoryComics = allComics.filter(
    (comic) => {
      const cat = categories.find((c) => c.id === categoryId);
      return cat && comic.category === cat.name;
    }
  );

  const displayComics = categoryComics.length > 0 ? categoryComics : allComics;

  if (!category) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-20 text-center">
            <h1 className="text-2xl font-heading text-foreground-900 mb-4">分类不存在</h1>
            <Link to="/" className="text-primary-500 hover:text-primary-600 text-sm whitespace-nowrap">
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  const breadcrumbListLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'http://jorjigsrp.com/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '分类浏览',
        item: `http://jorjigsrp.com/category/fantasy`,
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: category.name,
        item: `http://jorjigsrp.com/category/${category.id}`,
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(breadcrumbListLd),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: `${category.name} - 韩漫大全`,
            description: `韩漫大全${category.name}分类 - ${category.description}，收录${category.count}部韩国漫画无删减作品`,
            url: `http://jorjigsrp.com/category/${category.id}`,
            isPartOf: {
              '@type': 'WebSite',
              name: '韩漫大全',
              url: 'http://jorjigsrp.com/',
            },
          }),
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-8 md:py-12">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '分类浏览', href: '/category/fantasy' },
                { label: category.name },
              ]}
            />

            <div className="text-center mb-10">
              <span className="inline-block px-4 py-1.5 text-xs font-medium border border-foreground-200/70 rounded-full text-foreground-600 mb-4 whitespace-nowrap">
                共 {category.count} 部作品
              </span>
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                {category.name}
              </h1>
              <p className="text-sm text-foreground-500 max-w-lg mx-auto">
                {category.description}
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-2 mb-8 justify-center">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.id}`}
                  className={`px-4 py-1.5 text-xs font-medium rounded-full transition-all duration-200 whitespace-nowrap ${
                    cat.id === categoryId
                      ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                      : 'bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-primary-500'
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>

            {displayComics.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
                {displayComics.map((comic, index) => (
                  <ComicCard
                    key={comic.id}
                    {...comic}
                    isFirst={index === 0}
                  />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-500 text-sm">该分类暂无漫画，敬请期待</p>
              </div>
            )}
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}